<script setup lang="ts">
import { useAppStore } from '@/store/app';
import { AirdropItemStatus, AirdropStatus } from '@sonarwatch/portfolio-core';
import { PropType, computed } from 'vue';
const store = useAppStore();

const props = defineProps({
  airdropStatus: {
    type: String as PropType<AirdropStatus>,
    required: true,
  },
  claimStart: {
    type: Number,
    required: false,
  },
  claimEnd: {
    type: Number,
    required: false,
  },
  status: {
    type: String as PropType<AirdropItemStatus>,
    required: true,
  },
});

const params = computed(() => {
  const green = `green-${store.isDark ? 'lighten-3' : 'darken-1'}`;
  const red = `deep-orange-${store.isDark ? 'lighten-3' : 'lighten-1'}`;
  switch (props.status) {
    case AirdropItemStatus.claimed:
      return {
        color: green,
        icon: 'mdi-check',
        text: 'Eligible',
        textSecondary: 'Claimed',
      };
    case AirdropItemStatus.claimable:
      return {
        color: green,
        icon: 'mdi-check',
        text: 'Eligible',
        textSecondary: props.claimEnd
          ? `Claimable until ${new Date(props.claimEnd).toLocaleDateString()}`
          : undefined,
      };
    case AirdropItemStatus.potentiallyClaimable:
      return {
        color: green,
        icon: 'mdi-check',
        text: 'Eligible',
        textSecondary: undefined,
      };
    case AirdropItemStatus.claimableLater:
      return {
        color: green,
        icon: 'mdi-check',
        text: 'Eligible',
        textSecondary: 'Claims not yet opened',
      };
    case AirdropItemStatus.claimExpired:
      return {
        color: red,
        icon: 'mdi-close',
        text: 'Expired',
        textSecondary: props.claimEnd
          ? `Expired on ${new Date(props.claimEnd).toLocaleDateString()}`
          : 'Expired',
      };
    case AirdropItemStatus.ineligible:
      return {
        color: red,
        icon: 'mdi-close',
        text: 'Ineligible',
        textSecondary: undefined,
      };
    default:
      return {};
  }
});
</script>

<template>
  <div class="text-no-wrap">
    <v-chip
      class="px-4"
      :color="params.color"
      size="small"
      elevation="0"
      :prepend-icon="params.icon"
    >
      <span class="font-weight-medium">
        {{ params.text }}
      </span>
    </v-chip>
    <span
      v-if="params.textSecondary"
      class="ml-2 text-caption text-medium-emphasis"
    >
      {{ params.textSecondary }}
    </span>
  </div>
</template>
